'use client';

import { createContext } from 'react';
import { ConsentStatus } from '../types';

interface CookieConsentState {
    showBanner: boolean;
    showSettingsDialog: boolean;
    consentStatus: ConsentStatus;
    hasUserConsented: boolean;
}

interface CookieConsentActions {
    acceptAll: () => void;
    acceptOnlyNecessaryCookies: () => void;
    openSettings: () => void;
    closeSettings: () => void;
    saveSettings: (enableAnalytics: boolean) => void;
    dismissBanner: () => void;
}

export interface CookieConsentContextType extends CookieConsentState, CookieConsentActions {}

export const CookieConsentContext = createContext<CookieConsentContextType | null>(null);
